import React from 'react';
import { connect } from 'react-redux';
import { useLocale } from 'locale';
import BookmarkIcon from 'assets/svg/bookmark.svg';
import { navigateTo } from 'store/state/router/actions';
import { NavigateToFn, Route } from 'config/routes';
import { SavesButton as StyledSavesButton, SavesIcon } from './styled';

interface SavesButtonProps {
  navigate: NavigateToFn;
}

const SavesButtonBase: React.FC<SavesButtonProps> = ({ navigate }) => {
  const { t } = useLocale();

  return (
    <StyledSavesButton
      data-auto="investors_home_v2_header_saves_button"
      onClick={() => navigate(Route.InvestorsFavoriteNeighourhoodPage, {})}
    >
      <SavesIcon><BookmarkIcon /></SavesIcon>
      {t('investors.home.v2.header.savesButton')}
    </StyledSavesButton>
  );
};

const mapDispatchToProps = {
  navigate: navigateTo,
};

export const SavesButtonConnected = connect(null, mapDispatchToProps)(SavesButtonBase);
